import i18n from '@/plugins/i18n'
import { type NavAction, type NavItem, type NavItemContext, NavItemTypeEnum } from '@/common/types/navigation'
import { CaseActionModalEnum } from '@/common/types/caseAction'
import { BaseNavigationItemBuilder } from '@/agent/entities/navigation/BaseNavigationItemBuilder'

const { t } = i18n.global
export class CaseActionNavigationItemBuilder extends BaseNavigationItemBuilder {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  *buildNavigationItem(action: NavAction<any>, itemContext: NavItemContext): IterableIterator<NavItem> {
    if (action?.actionData?.action) {
      switch (action.actionData.action) {
        case 'TAKEON': {
          yield {
            ...this.getDefaultNavigationItem(action, itemContext, NavItemTypeEnum.ActionModal),
            target: CaseActionModalEnum.TAKEON,
          }
          break
        }
        case 'COMPLETE':
          yield { ...this.getDefaultNavigationItem(action, itemContext, NavItemTypeEnum.ActionModal), target: CaseActionModalEnum.COMPLETE }
          break
        case 'REOPEN':
          yield { ...this.getDefaultNavigationItem(action, itemContext, NavItemTypeEnum.ActionModal), target: CaseActionModalEnum.REOPEN }
          break
        case 'ASKFORVALIDATION':
          yield { ...this.getDefaultNavigationItem(action, itemContext, NavItemTypeEnum.ActionModal), target: CaseActionModalEnum.ASKFORVALIDATION }
          break
        case 'UNDOVALIDATION':
          yield { ...this.getDefaultNavigationItem(action, itemContext, NavItemTypeEnum.ActionModal), target: CaseActionModalEnum.UNDOVALIDATION }
          break
        case 'APPROVE':
          yield { ...this.getDefaultNavigationItem(action, itemContext, NavItemTypeEnum.ActionModal), target: CaseActionModalEnum.APPROVE }
          break
        case 'DISAPPROVE':
          yield { ...this.getDefaultNavigationItem(action, itemContext, NavItemTypeEnum.ActionModal), target: CaseActionModalEnum.DISAPPROVE }
          break
        case 'PUTBACKINPOOL':
          yield { ...this.getDefaultNavigationItem(action, itemContext, NavItemTypeEnum.ActionModal), target: CaseActionModalEnum.PUTBACKINPOOL }
          break
        case 'ASSIGN':
          yield { ...this.getDefaultNavigationItem(action, itemContext, NavItemTypeEnum.ActionModal), target: CaseActionModalEnum.ASSIGN }
          break
        case 'REASSIGN':
          yield { ...this.getDefaultNavigationItem(action, itemContext, NavItemTypeEnum.ActionModal), target: CaseActionModalEnum.REASSIGN }
          break
        case 'TRANSFER':
          yield { ...this.getDefaultNavigationItem(action, itemContext, NavItemTypeEnum.ActionModal), target: CaseActionModalEnum.TRANSFER }
          break
        case 'COMPLETEONVALIDATION':
          yield {
            ...this.getDefaultNavigationItem(action, itemContext, NavItemTypeEnum.ActionModal),
            target: CaseActionModalEnum.COMPLETEONVALIDATION,
          }
          break
        case 'DELETE':
          yield { ...this.getDefaultNavigationItem(action, itemContext, NavItemTypeEnum.ActionModal), target: CaseActionModalEnum.DELETE }
          break
        case 'STACK': {
          yield { ...this.getDefaultNavigationItem(action, itemContext, NavItemTypeEnum.ActionModal), target: CaseActionModalEnum.STACK }
          break
        }
        case 'STACKANDPUTBACKINPOOL': {
          yield {
            ...this.getDefaultNavigationItem(action, itemContext, NavItemTypeEnum.ActionModal),
            target: CaseActionModalEnum.STACKANDPUTBACKINPOOL,
          }
          break
        }
        case 'STACKANDREASSIGN': {
          yield {
            ...this.getDefaultNavigationItem(action, itemContext, NavItemTypeEnum.ActionModal),
            target: CaseActionModalEnum.STACKANDREASSIGN,
          }
          break
        }
        case 'STACKANDTRANSFER': {
          yield {
            ...this.getDefaultNavigationItem(action, itemContext, NavItemTypeEnum.ActionModal),
            target: CaseActionModalEnum.STACKANDTRANSFER,
          }
          break
        }
        case 'UPDATEDUEDATE': {
          yield {
            ...this.getDefaultNavigationItem(action, itemContext, NavItemTypeEnum.ActionModal),
            target: CaseActionModalEnum.UPDATEDUEDATE,
          }
          break
        }
        case 'ATTACHPARENT': {
          yield {
            ...this.getDefaultNavigationItem(action, itemContext, NavItemTypeEnum.ActionModal),
            target: CaseActionModalEnum.ATTACHPARENT,
          }
          break
        }
      }
    } else {
      console.log(`Case Navigation Action doesn't not have any targeted action`, action)
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getDefaultNavigationItem(action: NavAction<any>, itemContext: NavItemContext, type: NavItemTypeEnum = NavItemTypeEnum.Link): NavItem {
    const navItem = super.getDefaultNavigationItem(action, itemContext, type)
    navItem.category = action.actionData.action
    navItem.payload = {
      ...navItem.payload,
      ...this.context.getToken(),
      title: action.key ? t(action.key + '.title') : navItem.text,
    }

    return navItem
  }
}
